var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-img',{attrs:{"height":"250","contain":"","src":require('../assets/washi.png')}}),_c('div',{staticClass:"text-md-center"},[_vm._v("\n    "+_vm._s(_vm.nickname)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }